import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { IconBox, SubscriptionDetails } from 'components';
import _ from 'lodash';

// ************************** HELPER FUNCTION ************************** //
const equalItems = (item1, item2) => {
  return item1.map_regions ? (
    _.difference(item1.map_regions, item2.map_regions).length == 0 &&
    _.difference(item2.map_regions, item1.map_regions).length == 0
  ) : item1.quantity == item2.quantity;
}
// ********************************************************************* //

class SubscriptionCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.subscriptionModified = this.subscriptionModified.bind(this);
    this.generatePayload = this.generatePayload.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.CustomComponent = this.CustomComponent.bind(this);
  }

  subscriptionModified() {
    const { monthly_items, yearly_items } = this.generatePayload();
    if(this.props.subscriptions) {
      // ****** CHECK PREVIOUS SUBSCRIPTION HAD NO YEARLY/MONTHLY ITEMS, AND UPDATE DOES *** //
      const current_monthly_items = this.props.subscriptions.filter(s => s.interval == 'month');
      const current_yearly_items = this.props.subscriptions.filter(s => s.interval == 'year');
      if(
        current_yearly_items.length != yearly_items.length ||
        current_monthly_items.length != monthly_items.length
      ) {
        return true;
      }
      // *********************************************************************************** //
      for(const subscription of this.props.subscriptions) {
        if(subscription.interval == 'month') {
          if(monthly_items.length != subscription.items.length) {
            return true;
          }
          const modified_monthly_items = subscription.items.filter(subscription_item => {
            const current_monthly_item = monthly_items.find(i => i.plan == subscription_item.plan);
            if(!current_monthly_item) {
              return true;
            }

            return !equalItems(current_monthly_item, subscription_item);
          });

          if(modified_monthly_items.length > 0) {
            return true;
          }
        }
        else {
          const modified_yearly_items = subscription.items.filter(subscription_item => {
            if(yearly_items.length != subscription.items.length) {
              return true;
            }
            const current_yearly_item = yearly_items.find(i => i.plan == subscription_item.plan);
            if(!current_yearly_item) {
              return true;
            }

            return !equalItems(current_yearly_item, subscription_item);
          });

          if(modified_yearly_items.length > 0) {
            return true;
          }
        }
      }
      return false;
    }

    return true;
  }
  generatePayload() {
    const {
      plans,
      selected_map_city_regions,
      selected_map_state_regions,
      selected_map_national_plan,
      map_interval,
      data_items,
      canvassing_items
    } = this.props;
    let map_items = [];
    if(selected_map_national_plan) {
      const map_national_plan = plans.find(p => p.interval == map_interval && p.type == 'map_national');
      map_items = [ { plan: map_national_plan._id, quantity: 1 } ];
    }
    else {
      if(selected_map_city_regions.length > 0) {
        const map_city_plan = plans.find(p => p.interval == map_interval && p.type == 'map_city');
        map_items.push({ plan: map_city_plan._id, map_regions: selected_map_city_regions });
      }
      if(selected_map_state_regions.length > 0) {
        const map_state_plan = plans.find(p => p.interval == map_interval && p.type == 'map_state');
        map_items.push({ plan: map_state_plan._id, map_regions: selected_map_state_regions });
      }
    }
    const monthly_data_items = data_items
    .filter(item => item.plan.interval == 'month' && item.quantity)
    .map(item => ({ ...item, plan: item.plan._id }));

    const yearly_data_items = data_items
    .filter(item => item.plan.interval == 'year' && item.quantity)
    .map(item => ({ ...item, plan: item.plan._id }));

    const monthly_canvassing_items = canvassing_items
    .filter(item => item.plan.interval == 'month' && item.quantity)
    .map(item => ({ ...item, plan: item.plan._id }));

    const yearly_canvassing_items = canvassing_items
    .filter(item => item.plan.interval == 'year' && item.quantity)
    .map(item => ({ ...item, plan: item.plan._id }));

    const monthly_items = [
      ...(map_interval == 'month' ? map_items : []),
      ...monthly_data_items,
      ...monthly_canvassing_items
    ];
    const yearly_items = [
      ...(map_interval == 'year' ? map_items : []),
      ...yearly_data_items,
      ...yearly_canvassing_items
    ];

    return { monthly_items, yearly_items };
  }
  handleSave() {
    if(this.subscriptionModified()) {
      const { monthly_items, yearly_items } = this.generatePayload();
      if(this.props.updating) {
        this.props.handleUpdate(monthly_items, yearly_items);
      }
      else {
        this.props.handleCreate(monthly_items, yearly_items);
      }
    }
    else {
      this.props.resetPlanCalculator();
    }
  }
  CustomComponent() {
    const {
      plans,
      map_interval,
      map_regions,
      selected_map_city_regions,
      selected_map_state_regions,
      selected_map_national_plan,
      data_items,
      canvassing_items
    } = this.props;
    const  { monthly_items, yearly_items } = this.generatePayload();
    let save_button_text;
    if(monthly_items.length == 0 && yearly_items.length == 0) {
      save_button_text = 'Cancel Subscription';
    }
    else if(this.props.subscriptions != null) {
      save_button_text = this.subscriptionModified() ? 'Update Subscription' : 'Nothing Changed';
    }
    else {
      save_button_text = 'Create Subscription';
    }

    return (
      <div className='subscription-checkout-info-container'>
        {monthly_items.length == 0 && yearly_items.length == 0 ? (
          null
        ) : (
          <SubscriptionDetails
            monthly_items={monthly_items}
            yearly_items={yearly_items}
            plans={plans}
            map_regions={map_regions}
          />
        )}
        <Row>
          <Col md={12} xs={12}>
            <Button
              bsStyle='primary'
              block
              onClick={this.handleSave}
              disabled={!this.subscriptionModified()}
              >
              {save_button_text}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const  { monthly_items, yearly_items } = this.generatePayload();
    const wide_area = monthly_items.length > 0 && yearly_items.length > 0;
    const no_selection = monthly_items.length == 0 && yearly_items.length == 0;
    return (
      <Row>
        <Col
          lg={wide_area ? 12 : 6}
          md={wide_area ? 12 : 8}
          xs={12}
          lgOffset={wide_area ? 0 : 3}
          mdOffset={wide_area ? 0 : 2}
          >
          <IconBox
            show_icon={true}
            icon_class='fa fa-shopping-cart'
            title={no_selection ? 'No Plans Selected - $0' : 'CHECKOUT'}
            loading={this.props.saving_subscription}
            CustomComponent={this.CustomComponent()}
          />
        </Col>
      </Row>
    );
  }
}

export default SubscriptionCheckout;



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/SubscriptionCheckout.js